module.exports = __webpack_public_path__ + "media/images/iconTrendUp__inFrontOfAccent--dark-795f14f9d47ddbbac0ef3f39bfb2d707.png";